import { Spin } from 'antd'

/** Centered full-viewport spinner for route/app loading states. */
export function FullPageSpinner() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        width: '100%',
      }}
    >
      <Spin size="large" />
    </div>
  )
}
